export function dogObjectPronoun(sex: "male" | "female" | null | undefined): string {
  return sex === "female" ? "her" : "him"
}

export function dogPossessivePronoun(sex: "male" | "female" | null | undefined): string {
  return sex === "female" ? "her" : "his"
}

export function dogSubjectPronoun(sex: "male" | "female" | null | undefined): string {
  return sex === "female" ? "she" : "he"
}
